module.exports = __webpack_public_path__ + "static/media/6.question.ff881c7a.mp4";